import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import {
  AnalysisConfigurationGq,
  AnalysisConfigurationGqProps,
} from './../models/AnalysisConfigurationGq';

export function useGetAnalysisConfigurationsGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  return {
    query,
    result:
      (query?.data ?? query?.previousData)?.projects?.getAnalysisConfigurations
        ?.analysisConfigurations ?? [],
  };
}

const gqTag = gql`
  query GetAnalysisConfigurations($command: GetAnalysisConfigurationsCommand!) {
    projects {
      getAnalysisConfigurations(command: $command) {
        analysisConfigurations { ${AnalysisConfigurationGqProps} }
      }
    }
  }
`;

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
}

interface GQLData {
  readonly projects: {
    readonly getAnalysisConfigurations: {
      readonly analysisConfigurations: AnalysisConfigurationGq[];
    };
  };
}
